import { STATUS } from "@/constants/statuses";
import RewardsVerificationTokenStore from "@apps/rewards/modules/VerificationToken/store/RewardsVerificationTokenStore";
import { rewardsApplicationLoggerToken } from "@apps/rewards/tokens";
import { Observable, catchError, tap } from "rxjs";
import { inject, singleton } from "tsyringe";

import type { LoggerInterface } from "@interfaces/LoggerInterface";

import RewardsVerificationTokenApiService from "../api_service/RewardsVerificationTokenApiService";

@singleton()
class RewardsVerificationTokenService {
    constructor(
        @inject(rewardsApplicationLoggerToken)
        private readonly logger: LoggerInterface,
        private readonly verificationTokenApiService: RewardsVerificationTokenApiService,
        private readonly verificationTokenStore: RewardsVerificationTokenStore
    ) {}

    public sendVerificationToken(): Observable<unknown> {
        this.logger.debug(
            "RewardsVerificationTokenService.sendVerificationToken is started"
        );

        this.verificationTokenStore.setStatus(STATUS.LOADING);

        return this.verificationTokenApiService.sendVerificationToken().pipe(
            catchError((error: unknown) => {
                this.logger.debug(
                    "RewardsVerificationTokenService.sendVerificationToken is errored",
                    { error }
                );
                this.verificationTokenStore.setStatus(STATUS.ERROR);
                throw error;
            }),
            tap(() => {
                this.logger.debug(
                    "RewardsVerificationTokenService.sendVerificationToken is ready"
                );
                this.verificationTokenStore.setStatus(STATUS.READY);
            })
        );
    }
}

export default RewardsVerificationTokenService;
